import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Theme, Button } from '@pga/pga-component-library'

export const Title = styled.h4`
  color: ${Theme.colors.primary};
  font-family: ${Theme.fonts.PlayfairDisplay};
  font-size: ${props => props.fontSize || '26px'};
  font-weight: ${props => props.fontWeight || '600'};
  letter-spacing: -0.2px;
  line-height: 35px;
  margin-bottom: 1.5rem;
`
export const PaddedDiv = styled.div`
  padding: 3rem;
`

export const Paragraph = styled.p`
  color: ${Theme.colors.primary};
  font-family: ${Theme.fonts.Montserrat};
  font-size: 14px;
  line-height: 21px;
  margin-bottom: 1.5rem;
  a {
    color: ${Theme.colors.lightBlue};
  }
`

export const LoginButton = styled(Button)`
  font-family: ${Theme.fonts.Montserrat};
  font-size: 14px;
  line-height: 18px;
  display: inline-block;
  margin: 10px;
  width: 40%;
`
export const CancelButton = styled(Button)`
  font-family: ${Theme.fonts.Montserrat};
  font-size: 14px;
  line-height: 18px;
  display: inline-block;
  margin: 10px;
  width: 40%;
`
export const ReturnCancelButton = styled(CancelButton)`
  @media (max-width: 991.98px) {
    font-size: 11px;
    padding-right: 5px;
    padding-left: 5px;
  }
  @media (max-width: 499.98px) {
    font-size: 12px;
    white-space: normal;
    padding-top: 5px;
    padding-bottom: 5px;
  }
`
export const AnchorLink = styled.a`
  color: ${Theme.colors.lightBlue};
  font-family: ${Theme.fonts.Montserrat};
  font-size: 14px;
`
export const PgaLogoContainer = styled.div`
  display: inline-block;
  margin: 0px 20px 0px 0px;
  height: 70px;
  width: 61px;
  img {
    height:100%;
  }
`

const ReturnToJobSearch = ({ toggle }) => <Link to={{ pathname: '/' }}><ReturnCancelButton color='secondary' outline onClick={() => toggle()}>RETURN TO JOB SEARCH</ReturnCancelButton></Link>

const CancelComp = ({ toggleBack, history }) => <CancelButton color='secondary' outline onClick={() => toggleBack(history)}>CANCEL</CancelButton>

export const ModalCopyLogin = (history, location) => ({
  titleText: 'PGA Login Required',
  message: <Paragraph>You do not have permission to view this page. If you have a <strong>PGA Member</strong>, <strong>Student</strong>, or <strong>Associate</strong> login please login with that account to view this position.</Paragraph>,
  actionMessage: <Paragraph>For more information on how to become a PGA Member, <a href='https://beta.pga.org/membership/'>click here</a>.</Paragraph>,
  CancelComp
})

export const ModalCopyAccess = (history, location) => ({
  titleText: 'Access Denied',
  message: <Paragraph>This position is limited to PGA Professionals applicants. If you are a PGA Member, or currently working towards your membership, please login to continue.</Paragraph>,
  CancelComp: ReturnToJobSearch
})
